import { Box, Divider, ListItemText, Menu } from '@mui/material';
import { useMuiMenu } from 'shared/hooks';
import { Tenant } from 'shared/types';

import { AvailableTenant, User } from '../../types';
import LogoutButton from './LogoutButton';
import { MenuItemReadonly } from './styled';
import TenantsList from './TenantsList';
import UserAvatarCircle from './UserAvatarCircle';

interface AvatarWithTenantsProps {
    user: User;
    availableTenants: AvailableTenant[];
    onLogout: () => void;
    onTenantChange: (tenant: AvailableTenant) => void;
    selectedTenant: Tenant;
}

export default function AvatarWithTenants({ user, onLogout, availableTenants, onTenantChange, selectedTenant }: AvatarWithTenantsProps) {
    const filteredTenants = availableTenants.filter(tenant => tenant.roles.includes('Candidate'));
    const { openMenuButtonAnchor, open, handleMenuOpenClick, closeMenu } = useMuiMenu();

    return (
        <Box>
            <UserAvatarCircle user={ user }
                onClick={ handleMenuOpenClick } />

            <Menu anchorEl={ openMenuButtonAnchor }
                open={ open }
                onClose={ closeMenu }
            >
                <MenuItemReadonly disabled>
                    <ListItemText>{ user?.email }</ListItemText>
                </MenuItemReadonly>

                <Divider />

                <TenantsList availableTenants={ filteredTenants }
                    onTenantChange={ onTenantChange }
                    selectedTenant={ selectedTenant } />

                <Divider />

                <LogoutButton onClick={ onLogout } />
            </Menu>
        </Box>
    );
}
